import { render, staticRenderFns } from "./appCard.vue?vue&type=template&id=2ed485de&"
import script from "./appCard.vue?vue&type=script&lang=js&"
export * from "./appCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports